<dx-billing-transactions [accountNumber]="accountNumber" [policyNumber]="policyNumber" [uniqueDocs]="true">
</dx-billing-transactions>
